import React from "react";
import {
  useClearRefinements,
  useCurrentRefinements,
} from "react-instantsearch";
import { translate } from "../../../Services/translation";
import { isModifierClick } from "../utils/IsModifierClick";
import { CustomClearRefinementsProps } from "./types/CustomClearRefinementsProps";

const CustomCurrentRefinements = ({
  clearRefinementsProps,
  useCurrentRefinementsProps,
}: CustomClearRefinementsProps) => {
  const { canRefine: clearCanRefine, refine: clearRefine } =
    useClearRefinements(clearRefinementsProps);
  const { items: currentItems, refine: currentRefine } = useCurrentRefinements(
    useCurrentRefinementsProps
  );
  const totalRefinements = currentItems.reduce(
    (total, item) => total + item.refinements.length,
    0
  );

  return (
    <div
      className={`algolia-current-refinements ${
        clearCanRefine ? "" : "algolia-current-refinements--cannot-clear"
      }`}
    >
      <button
        disabled={!clearCanRefine}
        onClick={clearRefine}
        className="algolia-current-refinements__reset-button"
      >
        <span>{translate("algolia.results.clear-refinements.title")}</span>
        {totalRefinements > 0 && <span>({totalRefinements})</span>}
      </button>

      {currentItems.map((item) =>
        item.refinements.map((refinement) => (
          <button
            key={item.indexName + refinement.label + item.label}
            onClick={(event) => {
              if (isModifierClick(event)) {
                return;
              }

              currentRefine(refinement);
            }}
            className="algolia-current-refinements__current-button"
          >
            <div className="algolia-current-refinements__current-button__label">
              <span className="algolia-current-refinements__current-button__label__item">
                {item.label}
              </span>
              <span className="algolia-current-refinements__current-button__label__refinement">
                {refinement.attribute === "categories.lvl0" ? (
                  refinement.label.split(">").map((labelPart) => (
                    <span
                      key={
                        item.indexName +
                        refinement.label +
                        item.label +
                        labelPart
                      }
                      className="algolia-current-refinements__current-button__label__refinement__part"
                    >
                      {labelPart}
                    </span>
                  ))
                ) : (
                  <span>{refinement.label}</span>
                )}
              </span>
            </div>
            <div className="algolia-current-refinements__current-button__visual-close">
              <i className="ph-x"></i>
            </div>
          </button>
        ))
      )}
    </div>
  );
};

export default CustomCurrentRefinements;
